import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from './locales/fr.json';
import en from './locales/en.json';
import he from './locales/he.json';

// Configuration des langues
export const LANGUAGES = {
  fr: { name: 'Français', flag: '🇫🇷', dir: 'ltr' },
  en: { name: 'English', flag: '🇬🇧', dir: 'ltr' },
  he: { name: 'עברית', flag: '🇮🇱', dir: 'rtl' }
};

export const RTL_LANGUAGES = ['he', 'ar'];

export const isRTL = (lang) => RTL_LANGUAGES.includes(lang);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      he: { translation: he }
    },
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en', 'he'],
    
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'mutagim_language',
      caches: ['localStorage']
    },
    
    interpolation: {
      escapeValue: false
    },

    react: {
      useSuspense: false,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'span']
    }
  });

// Mise à jour de la direction du document quand la langue change
i18n.on('languageChanged', (lng) => {
  const dir = isRTL(lng) ? 'rtl' : 'ltr';
  document.documentElement.dir = dir;
  document.documentElement.lang = lng;
  
  // Mettre à jour les classes pour Tailwind
  if (dir === 'rtl') {
    document.documentElement.classList.add('rtl');
    document.documentElement.classList.remove('ltr');
  } else {
    document.documentElement.classList.add('ltr');
    document.documentElement.classList.remove('rtl');
  }
});

// Initialiser la direction au chargement
const initialLang = i18n.language || 'fr';
const initialDir = isRTL(initialLang) ? 'rtl' : 'ltr';
document.documentElement.dir = initialDir;
document.documentElement.lang = initialLang;

export default i18n;
